/**
 * This module adds merkleId to the User ID module
 */

import * as utils from 'prebid.js/src/utils.js'
import { ajax } from 'prebid.js/src/ajax.js'
import { submodule } from 'prebid.js/src/hook.js'

/** @type {Submodule} */
export const merkleIdSubmodule = {
  /**
   * used to link submodule with config
   * @type {string}
   */
  name: 'merkleId',
  /**
   * decode the stored id value for passing to bid requests
   * @function
   * @param {string} value
   * @returns {{idl_env:string}}
   */
  decode(value) {
    return value && value.ppid && value.ppid.id
      ? { merkel_id: value.ppid.id }
      : undefined
  },
  /**
   * performs action to obtain id and return a value in the callback's response argument
   * @function
   * @param {ConsentData} [consentData]
   * @param {SubmoduleParams} [configParams]
   * @returns {IdResponse|undefined}
   */
  getId(configParams, consentData) {
    if (
      !configParams ||
      typeof configParams.ptk !== 'string' ||
      !configParams.pubid
    ) {
      utils.logError(
        'identityLink submodule requires ptk and pubid id to be defined'
      )
      return
    }
    const hasGdpr =
      consentData &&
      typeof consentData.gdprApplies === 'boolean' &&
      consentData.gdprApplies
        ? 1
        : 0
    const gdprConsentString = hasGdpr ? consentData.consentString : ''

    // Uhhh, do do anything if we don't have consent??
    // THe API calls seem to fail if they come fom europe.
    if (hasGdpr && !gdprConsentString) {
      return { callback: (callback) => callback(undefined) }
    }
    // use protocol relative urls for http or https
    //const url = `https://api.rlcdn.com/api/identity/envelope?pid=${configParams.pid}${hasGdpr ? '&ct=1&cv=' + gdprConsentString : ''}`;
    const url = `https://mid.rkdms.com/idsv2?ptk=${configParams.ptk}&pubid=${configParams.pubid}`

    const resp = function(callback) {
      ajax(
        url,
        (response) => {
          let responseObj
          if (response) {
            try {
              responseObj = JSON.parse(response)
            } catch (error) {
              utils.logError(error)
            }
          }
          callback(responseObj)
        },
        undefined,
        { method: 'GET', withCredentials: true }
      )
    }

    return { callback: resp }
  }
}

submodule('userId', merkleIdSubmodule)
